import { queryOptions } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { ListingV2Response } from "@/types/listings-v2";
import { VEHICLE_SORTS, type VehicleSort } from "@/utils/vehicleSort";
import { LANDING_PAGE_SIZE, type LandingSlug, type LandingStats } from "@/lib/landingPages";

export const landingStatsQueryOptions = (slug: LandingSlug) =>
  queryOptions({
    queryKey: ["landing-stats", slug] as const,
    queryFn: async (): Promise<LandingStats> => {
      const { data, error } = await (supabase.rpc as any)("get_landing_page_stats", { p_slug: slug });
      if (error) throw error;
      const d = (data ?? {}) as Partial<LandingStats>;
      return { count: Number(d.count ?? 0), median_eur: d.median_eur == null ? null : Number(d.median_eur), top_makes: d.top_makes ?? [] };
    },
    staleTime: 5 * 60 * 1000,
  });

export const landingListingsQueryOptions = (slug: LandingSlug, sort: VehicleSort, page: number) =>
  queryOptions({
    queryKey: ["landing-listings", slug, sort, page] as const,
    queryFn: async (): Promise<{ listings: ListingV2Response[]; total: number }> => {
      const s = VEHICLE_SORTS[sort];
      const { data, error } = await (supabase.rpc as any)("get_landing_page_listings", {
        p_slug: slug,
        p_sort_by: s.sort_by,
        p_sort_order: s.sort_order,
        p_limit: LANDING_PAGE_SIZE,
        p_offset: (page - 1) * LANDING_PAGE_SIZE,
      });
      if (error) throw error;
      const rows = (data ?? []) as Array<ListingV2Response & { total_count: number }>;
      return { listings: rows, total: Number(rows[0]?.total_count ?? 0) };
    },
    staleTime: 5 * 60 * 1000,
  });
